(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec789"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec789"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jlUaU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e16b8da7da809cdc$export$71511d61b312f219; });

var $dTQYG = parcelRequire("dTQYG");

var $d95Qy = parcelRequire("d95Qy");

var $eanwW = parcelRequire("eanwW");

var $J66Jb = parcelRequire("J66Jb");
function $e16b8da7da809cdc$export$71511d61b312f219(arr) {
    return (0, $dTQYG._)(arr) || (0, $d95Qy._)(arr) || (0, $J66Jb._)(arr) || (0, $eanwW._)();
}

});
parcelRegister("dTQYG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a1e981ac9d7864a0$export$71511d61b312f219; });

var $2PuG4 = parcelRequire("2PuG4");
function $a1e981ac9d7864a0$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $2PuG4._)(arr);
}

});
parcelRegister("2PuG4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $20f8241f6119e7d1$export$71511d61b312f219; });
function $20f8241f6119e7d1$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("d95Qy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9920a6ac5bee97c9$export$71511d61b312f219; });
function $9920a6ac5bee97c9$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("eanwW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a504407b7f865a13$export$71511d61b312f219; });
function $a504407b7f865a13$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("J66Jb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0878f0e8b254b036$export$71511d61b312f219; });

var $2PuG4 = parcelRequire("2PuG4");
function $0878f0e8b254b036$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $2PuG4._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $2PuG4._)(o, minLen);
}

});



var $jlUaU = parcelRequire("jlUaU");
var $a44467f6bc263a26$var$selectors = {
    container: '.numbers',
    grid: 'div.numbers__grid',
    column: 'div.numbers__col',
    row: 'div.numbers__row',
    number: 'span.numbers__number'
};
var $a44467f6bc263a26$var$classNames = {
    show: 'show',
    bento: 'numbers--bento'
};
var $a44467f6bc263a26$var$animation = {
    defaultDuration: 2,
    frameRate: 25,
    threshold: 0.5
};
var $a44467f6bc263a26$var$reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
var $a44467f6bc263a26$var$isBento = function(container) {
    return container.classList.contains($a44467f6bc263a26$var$classNames.bento);
};
var $a44467f6bc263a26$var$isAnimating = function(container) {
    return container.dataset.animating === 'true';
};
var $a44467f6bc263a26$var$setAnimating = function(container, animating) {
    container.dataset.animating = animating ? 'true' : 'false';
};
var $a44467f6bc263a26$var$getNumber = function(value) {
    var number = parseFloat(value !== null && value !== void 0 ? value : '');
    return isNaN(number) ? null : number;
};
var $a44467f6bc263a26$var$updateBentoSizes = function(container) {
    if (!$a44467f6bc263a26$var$isBento(container)) return;
    var grid = container.querySelector($a44467f6bc263a26$var$selectors.grid);
    if (!grid) return;
    grid.style.setProperty('--item-width', "".concat(grid.clientWidth, "px"));
    grid.style.setProperty('--height', "".concat(grid.clientHeight, "px"));
    grid.style.setProperty('--width', "".concat(grid.scrollWidth, "px"));
    grid.querySelectorAll($a44467f6bc263a26$var$selectors.column).forEach(function(column) {
        column.style.setProperty('--offset-left', "".concat(column.offsetLeft * -1, "px"));
    });
};
var $a44467f6bc263a26$var$showNumberItems = function(container) {
    var itemSelector = $a44467f6bc263a26$var$isBento(container) ? $a44467f6bc263a26$var$selectors.row : $a44467f6bc263a26$var$selectors.column;
    container.querySelectorAll(itemSelector).forEach(function(item) {
        return item.classList.add($a44467f6bc263a26$var$classNames.show);
    });
};
var $a44467f6bc263a26$var$getAnimationDuration = function(numberEl) {
    var _numberEl_closest;
    var _numberEl_closest_dataset_duration;
    var duration = parseFloat((_numberEl_closest_dataset_duration = (_numberEl_closest = numberEl.closest($a44467f6bc263a26$var$selectors.grid)) === null || _numberEl_closest === void 0 ? void 0 : _numberEl_closest.dataset.duration) !== null && _numberEl_closest_dataset_duration !== void 0 ? _numberEl_closest_dataset_duration : '');
    return duration > 0 ? duration : $a44467f6bc263a26$var$animation.defaultDuration;
};
var $a44467f6bc263a26$var$getFormattedNumber = function(value) {
    var preventDecimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (preventDecimals) // Return rounded number if it's an integer
    return Math.round(value).toString();
    else // Return rounded number with 2 decimal places if it's a float
    return (Math.round(value * 100) / 100).toLocaleString(navigator.language);
};
var $a44467f6bc263a26$var$writeNumberValue = function(numberEl, value) {
    numberEl.innerText = value;
    if (numberEl.dataset.suffix) numberEl.innerText += "".concat(numberEl.dataset.suffix);
};
var $a44467f6bc263a26$var$animateNumber = function(numberEl, startNumber, endNumber, preventDecimals) {
    return new Promise(function(resolve) {
        var diff = Math.abs(endNumber - startNumber);
        var duration = $a44467f6bc263a26$var$getAnimationDuration(numberEl);
        var totalFrames = Math.max(1, Math.round(duration * $a44467f6bc263a26$var$animation.frameRate));
        var intervalSpeed = 1000 / $a44467f6bc263a26$var$animation.frameRate;
        var step = diff / totalFrames;
        var frame = 1;
        var interval = setInterval(function() {
            var calculatedNumber = startNumber < endNumber ? startNumber + step * frame : startNumber - step * frame;
            $a44467f6bc263a26$var$writeNumberValue(numberEl, $a44467f6bc263a26$var$getFormattedNumber(calculatedNumber, preventDecimals));
            if (frame >= totalFrames) {
                clearInterval(interval);
                resolve();
            }
            frame++;
        }, intervalSpeed);
    });
};
var $a44467f6bc263a26$var$showNumber = function(numberEl) {
    if (numberEl.dataset.textNumber) {
        $a44467f6bc263a26$var$writeNumberValue(numberEl, numberEl.dataset.textNumber);
        return null;
    }
    var startNumber = $a44467f6bc263a26$var$getNumber(numberEl.dataset.start);
    var endNumber = $a44467f6bc263a26$var$getNumber(numberEl.dataset.end);
    if (endNumber === null) return null;
    var endNumberIsInt = endNumber % 1 === 0;
    if (startNumber === null || $a44467f6bc263a26$var$reducedMotionQuery.matches) {
        $a44467f6bc263a26$var$writeNumberValue(numberEl, $a44467f6bc263a26$var$getFormattedNumber(endNumber, endNumberIsInt));
        return null;
    }
    return $a44467f6bc263a26$var$animateNumber(numberEl, startNumber, endNumber, endNumberIsInt);
};
var $a44467f6bc263a26$var$showAllNumbers = function(container) {
    if ($a44467f6bc263a26$var$isAnimating(container)) return;
    $a44467f6bc263a26$var$setAnimating(container, true);
    $a44467f6bc263a26$var$showNumberItems(container);
    var animations = (0, $jlUaU._)(container.querySelectorAll($a44467f6bc263a26$var$selectors.number)).map($a44467f6bc263a26$var$showNumber).filter(Boolean);
    if (!animations.length) {
        $a44467f6bc263a26$var$setAnimating(container, false);
        return;
    }
    Promise.all(animations).then(function() {
        return $a44467f6bc263a26$var$setAnimating(container, false);
    });
};
var $a44467f6bc263a26$var$onScreenEnter = function(entries) {
    entries.forEach(function(entry) {
        if (entry.isIntersecting) // The animation will trigger every time the element enters the viewport
        $a44467f6bc263a26$var$showAllNumbers(entry.target);
    });
};
var $a44467f6bc263a26$var$initNumbers = function() {
    var containers = document.querySelectorAll($a44467f6bc263a26$var$selectors.container);
    if (!containers.length) return;
    var observer = new IntersectionObserver($a44467f6bc263a26$var$onScreenEnter, {
        threshold: $a44467f6bc263a26$var$animation.threshold
    });
    containers.forEach(function(container) {
        $a44467f6bc263a26$var$updateBentoSizes(container);
        observer.observe(container);
    });
    window.addEventListener('resize', function() {
        containers.forEach(function(container) {
            return $a44467f6bc263a26$var$updateBentoSizes(container);
        });
    });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $a44467f6bc263a26$var$initNumbers);
else $a44467f6bc263a26$var$initNumbers();

})();
//# sourceMappingURL=numbers.min.js.map
